import $ from 'jquery';
// import 'jquery-ui-dist/jquery-ui.min.js' TODO: confirm if jQuery UI is still being used, we're using flatpickr for datepicker
import '@fancyapps/fancybox'
import './app.flatpickr'
import './app.a11yAccordionTabs'
import './app.slideshow'
import './app.validation'
import './app.toastNotifications'

$(document).ready(function () {});

/* ==========================================================================
   Sub nav toggle
   ========================================================================== */

const subNavItems = document.querySelectorAll('.js-toggle-subnav');

if (subNavItems) {
    subNavItems.forEach((subnav) => {
        subnav.addEventListener('click', (e) => toggleAccordion(e));
    });
}
const toggleAccordion = (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    if (!target.classList.contains('sub-nav--expand')) {
        subNavItems.forEach((item) => {
            item.classList.remove('sub-nav--expand');
        });
        target.classList.add('sub-nav--expand');
    } else {
        target.classList.remove('sub-nav--expand');
    }
};

/* ==========================================================================
   Mobile Menu Toggle
   ========================================================================== */

function toggleMenu() {
	document.getElementById("main-menu").classList.toggle("is-active");
}
window.toggleMenu = toggleMenu;

/* ==========================================================================
   Shrink Menu Toggle
   ========================================================================== */

function shrinkMenu() {
	document.getElementById("main-menu").classList.toggle("is-shrunk");
}
window.shrinkMenu = shrinkMenu;

/* ==========================================================================
   Modal Toggle
   ========================================================================== */

function openModal(el) {
	let targetModalId = null;

	if (el) {
		targetModalId = el.getAttribute('aria-controls');
	}

	// Fallback: if no aria-controls or element, try to find modal by some default ID or selector
	if (!targetModalId) {
		// For example, default to modal with id="modal-addRow"
		targetModalId = 'modal-addRow';
	}

	const modal = document.getElementById(targetModalId);
	if (modal) {
		modal.classList.add('is-active');
	} else {
		console.error(`Modal with id "${targetModalId}" not found.`);
	}
}
window.openModal = openModal;

function closeModal(el) {
	el.closest(".b-uikit-modal").classList.remove("is-active");
}
window.closeModal = closeModal;

/* ==========================================================================
   Button Menu Toggle
   ========================================================================== */

document.addEventListener('click', function (event) {
	const toggleBtn = event.target.closest('.js-toggle-button-menu');

	// Clicked on a toggle menu button
	if (toggleBtn) {
		event.preventDefault();
		event.stopImmediatePropagation();

		// Toggle current button and popout
		toggleBtn.classList.toggle("is-active");
		const popout = toggleBtn.nextElementSibling;
		if (popout && popout.classList.contains("b-uikit-button-menu__popout")) {
			popout.classList.toggle("is-active");
		}

		// Close others
		document.querySelectorAll('.js-toggle-button-menu').forEach((btn) => {
			if (btn !== toggleBtn) {
				btn.classList.remove("is-active");
				const otherPopout = btn.nextElementSibling;
				if (otherPopout && otherPopout.classList.contains("b-uikit-button-menu__popout")) {
					otherPopout.classList.remove("is-active");
				}
			}
		});
		return; // Prevent closing it below
	}

	// Clicked outside — close all
	if (!event.target.closest('.b-uikit-button-menu')) {
		document.querySelectorAll('.js-toggle-button-menu').forEach((btn) => btn.classList.remove("is-active"));
		document.querySelectorAll('.b-uikit-button-menu__popout').forEach((popout) => popout.classList.remove("is-active"));
	}
});

/* ==========================================================================
   Tooltip Popup Toggle
   ========================================================================== */

document.addEventListener('click', e => {
	if (e.target.closest('.js-toggle-tooltip-popup')) {
		e.preventDefault();
		const toolTipToggle = e.target.closest('.js-toggle-tooltip-popup');
		toolTipToggle.classList.toggle("is-active");
		toolTipToggle.nextElementSibling.classList.toggle("is-active");

		document.querySelectorAll('.js-toggle-tooltip-popup').forEach((elem) => {
			if (elem !== toolTipToggle) {
				elem.classList.remove("is-active");
				elem.nextElementSibling.classList.remove("is-active");
			}
		});
	}
});

document.addEventListener('click', e => {
	if (!e.target.closest('.b-uikit-tooltip-popup')) {
		document.querySelectorAll('.js-toggle-tooltip-popup').forEach((e) => {
			e.classList.remove("is-active");
		});
		document.querySelectorAll('.b-uikit-tooltip-popup__content').forEach((e) => {
			e.classList.remove("is-active");
		});
	}
});

/* ==========================================================================
   Copy to Clipboard
   ========================================================================== */

function copyToClipboard(token) {
	var $temp = $("<input>");
	$("body").append($temp);
	$temp.val(token).select();
	document.execCommand("copy");
	$temp.remove();
	alert("Token copied to clipboard");
};
window.copyToClipboard = copyToClipboard;


/* ==========================================================================
   Toast Notifications
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
	const triggers = document.querySelectorAll('.js-toast-trigger');

	triggers.forEach(function (trigger) {
		trigger.addEventListener('click', function (event) {
			event.preventDefault();
			const message = this.getAttribute('data-message') || 'Toast notification';
			const extraClasses = this.getAttribute('data-class') || '';
			toast(message, extraClasses);
		});
	});
});

const FADE_DUR = 500;
const DISPLAY_DUR = 3000;
let toastContain;

function toast(message, extraClasses) {
	// // 1. create global container for toast messages with class .toastContain
	if (!toastContain) {
		toastContain = document.createElement("div");
		toastContain.classList.add("toast-container--fixed");
		document.body.appendChild(toastContain);
	}

	// 2. append toast with classes .toast + extraClasses
	const EL = document.createElement("div");
	EL.classList.add("born-uikit-alert", "born-uikit-alert--small");
	if (extraClasses) {
		EL.classList.add(extraClasses);
	}
	EL.innerText = message;
	toastContain.prepend(EL);

	// 3. transition the toast message
	setTimeout(() => EL.classList.add("open"), 10); // delay so transitions apply
	setTimeout(() => EL.classList.remove("open"), DISPLAY_DUR);
	setTimeout(() => toastContain.removeChild(EL), DISPLAY_DUR + FADE_DUR);
}
